<template>
  <Loading v-if="!fullyLoaded" />
  <SubscriptionForm v-else :submit="submit" :sites="sites" :cancel="cancel" />
</template>

<script>
import CreateView from '@/mixins/createView';
import ResourceService from '@/services/resources/subscriptions_service';
import SiteService from '@/services/resources/sites_service';

export default {
  mixins: [CreateView],
  components: {
    SubscriptionForm: () => import('@/components/forms/SubscriptionForm.vue'),
  },
  data() {
    return {
      urlFragment: 'email-reports',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    sites: {
      get() {
        if (this.siteId) {
          return SiteService.get(this.siteId).then((site) => {
            return [site.data];
          });
        }

        return SiteService.index().then((sites) => {
          return sites.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
